import React from 'react'
import Store from '../../store/store'
import HeaderSteps from './headersteps'
import Upload from './steps/upload'
import Assignment from './steps/assignment'
import DownloadXml from './steps/downloadxml'
import i18 from '../../i18'
import api from '../../source/api'
import {Link} from 'react-router-dom'
import BaseComponent from '../base'
import Rules from './rules'

class Customer extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            editrules: false,
            company_id: props.location.match.params.id,
            currentStep: 1,
            userconfigs: {},
            company: {},
            onlineszamlaToken: false,

            invoices: [],
            customerRules: [],
            vatCollectorCodes: [],
        }
        this.store = Store
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        api.get({url: 'customer/init?company_id=' + this.state.company_id}, true).then((response) => {
            if (response.status === 200) {
                this.setState({
                    vatCollectorCodes: response.data.vatCollectorCodes,
                    userconfigs: response.data.userconfigs || {},
                    company: response.data.company,
                    customerRules: response.data.customerRules,
                    onlineszamlaToken: response.data.onlineszamlaToken
                })
            }
        })
    }

    componentDidMount = () => {
        window.scrollTo(0, 0)
    }

    setStep = (step) => {
        this.setState({currentStep: step});
    }

    nextStep = () => {
        this.setStep(this.state.currentStep + 1);
    }

    prevStep = () => {
        this.setStep(this.state.currentStep - 1);
    }

    editRules = () => {
        this.setState({editrules: !this.state.editrules})
    }

    updateInvoices = (invoices, customerRules) => {
        let self = this;
        let addRuleCount = 0;
        let removeRuleCount = 0;

        invoices.map(function (invoice) {
            invoice.items.map(function (invoiceItem) {
                let selectedRule = self.invoiceItemFindRule(invoice, invoiceItem, customerRules);

                if (selectedRule) {
                    // talált a tételhez szabályt

                    if (invoiceItem.rule_id !== selectedRule.id) {
                        // eltérő szabály, tehát beállítja, és számolja
                        invoiceItem.rule_id = selectedRule.id;
                        addRuleCount++;
                    }
                } else if (invoiceItem.rule_id) {
                    // meglévő szabályt törli
                    invoiceItem.rule_id = null;
                    removeRuleCount++;
                }
            });
        });

        this.setState({
            invoices: invoices,
            customerRules: customerRules,
        })

        return {
            addRuleCount: addRuleCount,
            removeRuleCount: removeRuleCount,
        };
    };

    updateConfig = (config) => {
        this.setState({userconfigs: config});
    }

    invoiceItemFindRule = (invoice, invoiceItem, customerRules) => {
        for (let ruleIndex in customerRules) {
            if (this.invoiceCheckRule(invoice, invoiceItem, customerRules[ruleIndex])) {
                return customerRules[ruleIndex];

            }
        }
        return null;
    }

    invoiceCheckRule = (invoice, invoiceItem, rule) => {
        return (rule.item_name === '' || invoiceItem.name.toLowerCase().indexOf(rule.item_name.toLowerCase()) !== -1)
            && (rule.invoice_number === '' || invoice.invoiceNumber.toLowerCase().indexOf(rule.invoice_number.toLowerCase()) !== -1)
            && rule.company_type === invoice.company_type
            && parseInt(rule.vat, 0) === parseInt(invoiceItem.vat, 0);
    }


    render() {
        return (
            <section id='customer-upload'>
                <div className={!this.state.editrules ? '' : 'd-none'}>
                    <HeaderSteps setStep={(step) => this.setStep(step)} currentStep={this.state.currentStep}/>
                    <div className='header'>
                        <div className='container'>
                            <h1 className='margin-bottom-50'>{i18.CUSTOMER._title}</h1>
                            <p>{i18.CUSTOMER._description}</p>
                            <div className="row" style={{marginBottom: "50px"}}>
                                <div className="col-md-12">
                                    <div className="pull-left">
                                        <h4 className='text-left'>Kiválasztott cég: {this.state.company ? this.state.company.name : ''} (<Link to='/' className='link-color'>cég csere</Link>)</h4>
                                    </div>
                                    <div className="pull-right">
                                        <Link className={this.state.company.onlineszamlaToken ? 'table-green-btn' : 'table-gray-btn'} to={`/company/onlineszamla/${this.state.company.id}`}>Onlineszámla API</Link>&nbsp;
                                        <a onClick={() => this.editRules()} className="table-green-btn">Szabályok</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={this.state.editrules ? 'container-fluid' : 'd-none'}>
                    <Rules
                        company={this.state.company}
                        userconfigs={this.state.userconfigs}
                        invoices={this.state.invoices}
                        vatCollectorCodes={this.state.vatCollectorCodes}
                        customerRules={this.state.customerRules}
                        editRules={() => this.editRules()}
                        updateInvoices={(invoices, customerRules) => this.updateInvoices(invoices, customerRules)}
                    />
                </div>
                <div className={!this.state.editrules ? 'upload-body' : 'd-none'}>
                    <div className={this.state.currentStep === 1 ? 'container' : 'd-none'}>
                        <Upload
                            {...this.props}
                            company={this.state.company}
                            userconfigs={this.state.userconfigs}
                            onlineszamlaToken={this.state.onlineszamlaToken}
                            customerRules={this.state.customerRules}

                            nextStep={() => this.nextStep()}
                            updateInvoices={(invoices, customerRules) => this.updateInvoices(invoices, customerRules)}
                            updateConfig={(config) => this.updateConfig(config)}
                        />
                    </div>
                    <div className={this.state.currentStep === 2 ? 'container-fluid' : 'd-none'}>
                        <Assignment
                            {...this.props}
                            company={this.state.company}
                            userconfigs={this.state.userconfigs}
                            invoices={this.state.invoices}
                            vatCollectorCodes={this.state.vatCollectorCodes}
                            customerRules={this.state.customerRules}

                            setInvoices={() => this.setInvoices()}
                            nextStep={() => this.nextStep()}
                            updateInvoices={(invoices, customerRules) => this.updateInvoices(invoices, customerRules)}
                        />
                    </div>
                    <div className={this.state.currentStep === 3 ? 'container-fluid' : 'd-none'}>
                        <DownloadXml
                            {...this.props}
                            company={this.state.company}
                            invoices={this.state.invoices}
                            nextStep={() => this.nextStep()}
                        />
                    </div>
                </div>
            </section>
        )
    }
}

export default Customer


// WEBPACK FOOTER //
// ./src/components/customer/customer.js